import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaStore,
  FaLaptopCode,
  FaRocket,
  FaMobileAlt,
  FaShieldAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const OnlineStoreDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Online Store Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your Digital Storefront</Subheading>}
        heading={
          <Heading>
            Online Store <span tw="text-primary-500">Development</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in online store development in **Bur
            Dubai**, creating custom, high-performing e-commerce platforms that
            drive sales and elevate your brand. Launch your business online with
            a solution built for success.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1612469293568-38a5cdbdb5cc?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Online Store Development in Bur Dubai"
        description="We deliver tailored e-commerce solutions to meet your unique needs."
        cards={[
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Custom Stores",
            description: "Bespoke designs that reflect your brand identity.",
          },
          {
            icon: <FaLaptopCode color="#ff5464" size={40} />,
            title: "Advanced Technology",
            description: "Built with the latest tools for optimal performance.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Deployment",
            description:
              "Launch your store quickly without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Ready",
            description: "Seamless shopping experiences on all devices.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure & Reliable",
            description: "Safe transactions and scalable infrastructure.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Excellence",
            description: "Trusted by Bur Dubai businesses for top results.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Online Store Development Process"
        description={
          <Description>
            We craft your online store with a structured, client-focused
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your vision and business goals.</li>
              <li>Design: Create a visually appealing and intuitive layout.</li>
              <li>Development: Build a robust platform with key features.</li>
              <li>Integration: Add payment gateways, shipping, and more.</li>
              <li>
                Testing: Ensure functionality and performance across devices.
              </li>
              <li>
                Launch & Support: Deploy and maintain your store for success.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1526406915894-7bcd65f60845?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Online Store Success in Bur Dubai"
        description="Our development expertise has empowered local businesses."
        cards={[
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Increased revenue by 180% for a new online store.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Launch",
            description: "Launched a store in 3 weeks with full features.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% of clients rate us 5 stars for our work.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell Online?</Subheading>}
        heading="Your Online Store in Bur Dubai Awaits"
        description={
          <Description>
            Partner with MilaajBrandset for expert online store development in
            Bur Dubai. Build a custom, high-performing e-commerce platform that
            grows your business—get started today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1532363814356-df99100ae399?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1475873326779-3eae1a9c0d13?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
